import { render, staticRenderFns } from "./schoolView.vue?vue&type=template&id=967cd41c"
import script from "./schoolView.vue?vue&type=script&lang=js"
export * from "./schoolView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zkdn_workspace\\zhijiao\\bjzyjy-mhwz\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('967cd41c')) {
      api.createRecord('967cd41c', component.options)
    } else {
      api.reload('967cd41c', component.options)
    }
    module.hot.accept("./schoolView.vue?vue&type=template&id=967cd41c", function () {
      api.rerender('967cd41c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/backstage/school/schoolView.vue"
export default component.exports